import { Palette } from '../constants/palette';
export const cardColors = {
    cardBorder: Palette.gray60,
    cardBackground: Palette.white,
    cardBorderHover: Palette.darkBlue,
    cardBorderActive: Palette.royalBlue,
    cardBorderFocus: Palette.darkBlue,
};
export const card = {
    base: {
        display: 'inline-block',
        borderRadius: '16px',
        padding: '24px',
        backgroundColor: cardColors.cardBackground,
        border: `1px solid ${cardColors.cardBorder}`,
        '&:focus[role="button"], &:focus[role="radio"]': {
            borderColor: cardColors.cardBorderHover,
            /* for card focus we have 3 borders. the normal one, then a white one on
             * the inside, then a normal one on the inside
             */
            boxShadow: `0 0 0 1px inset ${cardColors.cardBackground}, 0 0 0 2px inset ${cardColors.cardBorderFocus}`,
        },
        '&:hover[role="button"], &:hover[role="radio"]': {
            borderColor: cardColors.cardBorderHover,
        },
        '&:active[role="button"], &:active[role="radio"]': {
            borderColor: cardColors.cardBorderActive,
            boxShadow: `0 0 0 1px inset ${cardColors.cardBorderActive}`,
        },
    },
    variants: {
        outline: {
        /* outline is default */
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FyZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90aGVtZS9jYXJkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxzQkFBc0IsQ0FBQztBQUcvQyxNQUFNLENBQUMsTUFBTSxVQUFVLEdBQUc7SUFDeEIsVUFBVSxFQUFFLE9BQU8sQ0FBQyxNQUFNO0lBQzFCLGNBQWMsRUFBRSxPQUFPLENBQUMsS0FBSztJQUM3QixlQUFlLEVBQUUsT0FBTyxDQUFDLFFBQVE7SUFDakMsZ0JBQWdCLEVBQUUsT0FBTyxDQUFDLFNBQVM7SUFDbkMsZUFBZSxFQUFFLE9BQU8sQ0FBQyxRQUFRO0NBQ3pCLENBQUM7QUFFWCxNQUFNLENBQUMsTUFBTSxJQUFJLEdBQWtCO0lBQ2pDLElBQUksRUFBRTtRQUNKLE9BQU8sRUFBRSxjQUFjO1FBQ3ZCLFlBQVksRUFBRSxNQUFNO1FBQ3BCLE9BQU8sRUFBRSxNQUFNO1FBQ2YsZUFBZSxFQUFFLFVBQVUsQ0FBQyxjQUFjO1FBQzFDLE1BQU0sRUFBRSxhQUFhLFVBQVUsQ0FBQyxVQUFVLEVBQUU7UUFDNUMsK0NBQStDLEVBQUU7WUFDL0MsV0FBVyxFQUFFLFVBQVUsQ0FBQyxlQUFlO1lBQ3ZDOztlQUVHO1lBQ0gsU0FBUyxFQUFFLG1CQUFtQixVQUFVLENBQUMsY0FBYyxxQkFBcUIsVUFBVSxDQUFDLGVBQWUsRUFBRTtTQUN6RztRQUNELCtDQUErQyxFQUFFO1lBQy9DLFdBQVcsRUFBRSxVQUFVLENBQUMsZUFBZTtTQUN4QztRQUNELGlEQUFpRCxFQUFFO1lBQ2pELFdBQVcsRUFBRSxVQUFVLENBQUMsZ0JBQWdCO1lBQ3hDLFNBQVMsRUFBRSxtQkFBbUIsVUFBVSxDQUFDLGdCQUFnQixFQUFFO1NBQzVEO0tBQ0Y7SUFDRCxRQUFRLEVBQUU7UUFDUixPQUFPLEVBQUU7UUFDUCx3QkFBd0I7U0FDekI7S0FDRjtDQUNGLENBQUMifQ==